import $ from "jquery";
import CONFIG from "@bd-core/config";

const Storage = (function () {
    var ls = {};

    ls.getPrefix = function () {
        return `g-${CONFIG.game.id}-`;
    };

    ls.hasPrefix = function (key) {
        var prefix = this.getPrefix();
        return key.search(prefix) !== -1 ? true : false;
    };

    ls.addKeyPrefix = function (key) {
        return this.hasPrefix(key) ? key : this.getPrefix() + key;
    };

    ls.hasData = function (key) {
        key = this.addKeyPrefix(key);

        return !!localStorage[key] && !!localStorage[key].length;
    };
    ls.get = function (key, defaultValue) {
        key = this.addKeyPrefix(key);

        if (!this.hasData(key)) {
            return defaultValue;
        }
        var data = localStorage[key];

        try {
            return JSON.parse(data);
        } catch (e) {
            return data;
        }
    };
    ls.set = function (key, value) {
        key = this.addKeyPrefix(key);

        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            localStorage.setItem(key, value);
        }
    };
    ls.extend = function (key, value) {
        key = this.addKeyPrefix(key);
        if (this.hasData(key)) {
            var _value = this.get(key);
            $.extend(_value, JSON.parse(JSON.stringify(value)));
            this.set(key, _value);
        } else {
            this.set(key, value);
        }
    };
    ls.remove = function (key) {
        key = this.addKeyPrefix(key);
        localStorage.removeItem(key);
    };
    return ls;
})();

export default Storage;
